module.exports = __webpack_public_path__ + "static/turtles-all-the-way-down-023f159da45905f199d85b8a148e4b18.jpg";